import React, { FC } from 'react';
import { ReactComponent as AddIcon } from 'assets/icons/add-counter-icon.svg';
import { ReactComponent as MinusIcon } from 'assets/icons/minus-counter-icon.svg';

type CounterType = { count: number; setCount: (arg1: number) => void; disabled?: boolean };
export const Counter: FC<CounterType> = ({ count, setCount, disabled }) => {
  return (
    <div className='flex gap-4 mt-2'>
      {!disabled && <AddIcon className='cursor-pointer' onClick={() => setCount(count + 1)} />}
      <p>{count === 0 ? 'Nil' : count}</p>
      {count > 0 && !disabled && (
        <MinusIcon className='cursor-pointer' onClick={() => setCount(count - 1)} />
      )}
    </div>
  );
};
